import { Box } from "@mantine/core";
import { IconTruckLoading } from "@tabler/icons-react";
import ShortActivityInfo from "components/ShortActivityInfo";
import InfoItem from ".";

interface InfoItemCargoProps {
  loadingMeter: number;
  unitAmount: number;
  unitCode: string;
}

const InfoItemCargo: React.FC<InfoItemCargoProps> = ({
  loadingMeter,
  unitAmount,
  unitCode,
}) => {
  return (
    <InfoItem
      icon={<IconTruckLoading />}
      label={
        <Box p={4} className="rounded-md w-fit">
          <ShortActivityInfo
            cargo={{
              loadingMeter,
              unit: {
                code: unitCode,
              },
              unitAmount,
            }}
          />
        </Box>
      }
    />
  );
};

export default InfoItemCargo;
